/** Synology Hyper Backup and Cloud Sync helpers for the estate Backup page. */

export const HYPERBACKUP_SLUG = 'hyperbackup-status'
export const CLOUDSYNC_SLUG = 'cloudsync-status'
export const NAS_HEALTH_SLUG = 'nas-health-status'

export function asHyperbackupTaskArray(value) {
  if (value == null) return []
  if (Array.isArray(value)) return value
  if (typeof value === 'object') return [value]
  return []
}

export function asCloudSyncConnectionArray(value) {
  if (value == null) return []
  if (Array.isArray(value)) return value
  if (typeof value === 'object') return [value]
  return []
}

export function hostKindLabel(kind) {
  switch (kind) {
    case 'altaro':
      return 'Altaro'
    case 'synology':
      return 'Synology Hyper Backup'
    case 'synology_cloudsync':
      return 'Synology Cloud Sync'
    case 'synology_both':
      return 'Synology NAS'
    case 'mixed':
      return 'Altaro + Synology'
    default:
      return 'Backup host'
  }
}

export function cloudSyncStatusBadgeVariant(status) {
  const normalised = String(status || '').toLowerCase()
  if (normalised === 'success') return 'success'
  if (normalised === 'syncing') return 'secondary'
  if (normalised === 'warning') return 'warning'
  if (normalised === 'failed') return 'destructive'
  return 'secondary'
}

export function nasHealthStatusBadgeVariant(status) {
  return cloudSyncStatusBadgeVariant(status)
}
